import { IStore } from '@dataTypes/userInfo';
import { PAYMETHOD, TRANSACTION } from '@dataTypes/totalSalesTypes';

/** 현재 선택 지점에서 마일리지(현금) 항목을 UI에 표시할지 여부 */
export function isMileageDisplayEnabled(
  currentStoreId: number | undefined,
  storeLists: IStore[] | undefined,
): boolean {
  if (currentStoreId == null) return true;
  const row = storeLists?.find((s) => s.storeId === currentStoreId);
  if (row?.mileageDisplayYn == null || row.mileageDisplayYn === '') return true;
  return row.mileageDisplayYn.trim().toUpperCase() !== 'N';
}

/** 지점 설정으로 마일리지 비표시 시 CASH 거래는 라벨을 숨김 */
export function formatPayMethodLabel(
  showMileage: boolean,
  method: PAYMETHOD,
  status: TRANSACTION,
): string {
  if (!showMileage && method === PAYMETHOD.CASH) {
    return '—';
  }
  if (status === TRANSACTION.C) {
    switch (method) {
      case PAYMETHOD.CARD:
        return '카드 취소';
      case PAYMETHOD.CASH:
        return '마일리지 취소';
      case PAYMETHOD.ETC:
        return '기타 취소';
      default:
        return '알 수 없음 취소';
    }
  }
  switch (method) {
    case PAYMETHOD.CARD:
      return '카드';
    case PAYMETHOD.CASH:
      return '마일리지';
    case PAYMETHOD.ETC:
      return '기타';
    default:
      return '알 수 없음';
  }
}
